export default __webpack_public_path__ + "static/media/chat-ic.df40190e.svg";